import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardUserPlusIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 10.1367V4.13672M16 7.13672H22M16 21.1367V19.9367C16 18.2566 16 17.4165 15.673 16.7747C15.3854 16.2103 14.9265 15.7513 14.362 15.4637C13.7202 15.1367 12.8802 15.1367 11.2 15.1367H6.8C5.11984 15.1367 4.27976 15.1367 3.63803 15.4637C3.07354 15.7513 2.6146 16.2103 2.32698 16.7747C2 17.4165 2 18.2566 2 19.9367V21.1367M12.5 7.63672C12.5 9.56972 10.933 11.1367 9 11.1367C7.067 11.1367 5.5 9.56972 5.5 7.63672C5.5 5.70372 7.067 4.13672 9 4.13672C10.933 4.13672 12.5 5.70372 12.5 7.63672Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardUserPlusIcon;
